<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col>
            <div class="font-weight-bold mt-6 title-page">Recuperação de Senha</div>
            <p class="mt-2">
              Informe o seu e-mail. Você receberá um código para redefinir sua senha.
            </p>
          </v-col>
        </v-row>

        <v-form ref="form" v-model="validForm" @submit.prevent="finish">
          <v-row>
            <v-col>
              <v-radio-group v-model="type" row hide-details="auto" class="mt-0">
                <v-radio label="Credor" :value="1"></v-radio>
                <v-radio label="Procurador" :value="2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                dense
                label="E-mail"
                v-model="email"
                required
                :rules="[$rules.required, $rules.email]"
                outlined
                hide-details="auto"
                @keyup.enter="finish"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-text>
        <v-btn color="primary" @click="finish" :loading="loading" :disabled="!validForm">
          Enviar
        </v-btn>
        <v-btn color="grey" text @click="goBack">
          Cancelar
        </v-btn>
      </v-card-text>
    </v-card>

    <reset-password-with-code
      :value="showReset"
      :email="email"
      :type="type"
      @input="showReset = $event"
      @success="onResetSuccess"
    />
  </div>
</template>

<script>
import axios from "axios";
import { eventHub } from "@/main";
import ResetPasswordWithCode from "./ResetPasswordWithCode.vue";

export default {
  components: {
    ResetPasswordWithCode
  },

  data: () => ({
    loading: false,
    validForm: false,
    email: "",
    type: 1,
    showReset: false
  }),

  methods: {
    goBack() {
      eventHub.$emit('DIALOG-FORGOT-PASSWORD', false);
      this.email = "";
      this.type = 1;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },

    async finish() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      try {
        const { data } = await axios.post('/api/users/forgot-password', {
          email: this.email,
          type: this.type
        });

        if (data.status) {
          this.showReset = true;
          this.$dialog.notify.success("Código enviado para o seu e-mail!", { 
            position: 'top-right', 
            timeout: 3000 
          });
        } else {
          throw new Error("Erro ao processar solicitação.");
        }

      } catch (error) {
        // Tratamento de erro robusto
        const message = error.response && error.response.data.error 
          ? error.response.data.error.message 
          : "E-mail não encontrado ou erro no servidor.";

        this.$dialog.notify.error(message, { 
          position: 'top-right', 
          timeout: 5000 
        });
      } finally {
        this.loading = false;
      }
    },

    onResetSuccess() {
      this.showReset = false;
      this.email = "";
      this.goBack(); 
    }
  }
};
</script>
